import React, { CSSProperties, FunctionComponent, memo, useState } from 'react'
import styles from './TaskMobile.module.sass'
import { ID } from '../../../../../../types/UtilityTypes'
import { lineTasksSelector, taskSelector } from '../../../../../../utils/selectors'
import { EMPTY_TASK, taskStatusToColor } from '../../../../../../responses/tasks'
import { useRootDispatch, useRootSelector } from '../../../../../../utils/hooks'
import { taskActions } from '../../../../../../redux/data/task/task-actions'
import Button from '../../../../../controls/Button/Button'
import PlusIcon from 'files/plus.svg'
import ChevronRightIcon from 'files/chevron/right.svg'
import Spacer from '../../../../../etc/Spacer'
import { shallowEqual } from 'react-redux'
import equal from 'fast-deep-equal'
import TaskContent from '../../../../../etc/TaskContent/TaskContent'
import TaskTabs from '../../../../../navigation/TaskTabs/TaskTabs'
import { TaskEditState } from '../../../../../../redux/data/task/task-reducer'
import { setLightness } from 'polished'

interface Props {
    taskId: ID,
    parentId: ID,
    objectId: ID,
    projectId: ID,
    hideLink?: boolean,
    onChange: (taskId: ID) => void,
}

const TaskMobile: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const task = useRootSelector(state => taskSelector(props.taskId)(state), shallowEqual) ?? EMPTY_TASK
    const line = useRootSelector(lineTasksSelector(props.parentId), equal)
    const editState = useRootSelector(state => state.data.task.editState)
    const [_open, setOpen] = useState(false)
    const open = line.length > 1 && _open

    const isAppend = TaskEditState.is.append(editState) && editState.parentId == props.parentId

    return <div
        className={styles.task}
        style={{'--background': setLightness(0.95, taskStatusToColor(task.status_id))} as CSSProperties}
    >
        <div className={styles.navigation}>
            <TaskTabs
                items={line}
                activeId={props.taskId}
                onChange={taskId => {
                    props.onChange(taskId)
                    setOpen(false)
                }}
                minimal={!open}
                append={isAppend}
                editedId={TaskEditState.is.update(editState) ? editState.task.id: undefined}
            />
            {
                    !open && <>
                        {
                            line.length > 1 && <Button className={styles.toggle} onClick={() => setOpen(!open)}>
                                <ChevronRightIcon/>
                            </Button>
                        }
                        <Spacer/>
                        {
                            !isAppend && <Button
                                onClick={() => {
                                    props.onChange(EMPTY_TASK.id)
                                    dispatch(taskActions.startAppend({
                                        objectId: props.objectId,
                                        parentId: props.parentId, // if task is parent
                                    }))
                                }}
                            >
                                <PlusIcon/>
                            </Button>
                        }
                    </>
            }
        </div>
        <div className={styles.content}>
            <TaskContent
                task={task}
                parentId={props.parentId}
                objectId={props.objectId}
                projectId={props.projectId}
                hideLink={props.hideLink}
            />
        </div>
    </div>
}

export default memo(TaskMobile)